import { render, staticRenderFns } from "./DropDownFeedback.vue?vue&type=template&id=28576487&scoped=true&lang=pug"
import script from "./DropDownFeedback.vue?vue&type=script&lang=ts"
export * from "./DropDownFeedback.vue?vue&type=script&lang=ts"
import style0 from "./DropDownFeedback.vue?vue&type=style&index=0&id=28576487&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28576487",
  null
  
)

export default component.exports